module.exports = __webpack_public_path__ + "static/img/barclays.af21a50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/brands-that-trust-us/barclays.png
// module id = reHo
// module chunks = 1